import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import "./createAccount.css";
import { useDispatch, useSelector } from "react-redux";
import { createAccount, setRegistrationInfo } from "../../../appState/slices/auth/authSlice";
import { getCMS } from "../../../appState/slices/cms/cmsSlice";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
const CreateAccount = ({ setOtpScreen, handleSendOtp, onCaptchaReady }) => {
  const { page: cmsPage } = useSelector((state) => state.cms);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm(); const registrationInfo = useSelector(state => state.auth.registrationInfo)
  const dispatch = useDispatch();
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");



useEffect(() => {
  const captcha = document.getElementById("msg91-captcha");

  if (captcha && onCaptchaReady) {
    onCaptchaReady();
  }
}, [onCaptchaReady]);

const onSubmit = (data) => {
  data.termsAccepted = true;
  data.termsversion = "1.0";

  data.privacyAccepted = true;
  data.privacyversion = "1.0";

  dispatch(setRegistrationInfo(data));

  handleSendOtp(data.phoneNumber);
};

  const openPolicy = (slug, title) => {
    setModalTitle(title);
    dispatch(getCMS(slug));
    setShowPolicyModal(true);
  };


  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="create-account-container"
    >
      <div>
        <Controller
          name="name"
          control={control}
          defaultValue=""
          rules={{
            required: "Please enter your name.",
            minLength: {
              value: 2,
              message: "Name must be at least 2 characters long.",
            },
            maxLength: {
              value: 50,
              message: "Name cannot exceed 50 characters.",
            },
            pattern: {
              value: /^[A-Za-z\s]+$/,
              message: "Name can only contain letters and spaces.",
            },
          }}
          render={({ field }) => (
            <div className="input-container">
              <input
                type="text"
                placeholder="NAME"
                {...field}
              />
              {errors.name && <p className="terms-error">{errors.name.message}</p>}
            </div>
          )}
        />
      </div>

      <div>
        <Controller
          name="email"
          control={control}
          defaultValue=""
          rules={{
            required: "Please enter your email.",
            pattern: {
              value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
              message: "Please enter a valid email address.",
            },
          }}
          render={({ field }) => (
            <div className="input-container">
              <input
                type="email"
                placeholder="EMAIL"
                {...field}
              />
              {errors.email && <p className="terms-error">{errors.email.message}</p>}
            </div>
          )}
        />
      </div>

      <div>
        <Controller
          name="password"
          control={control}
          defaultValue=""
          rules={{
            required: "Please enter a password.",
            minLength: {
              value: 8,
              message: "Password must be at least 8 characters long.",
            },
            maxLength: {
              value: 50,
              message: "Password cannot exceed 50 characters.",
            },
          }}
          render={({ field }) => (
            <div className="input-container">
              <input
                type="password"
                placeholder="PASSWORD"
                {...field}
              />
              {errors.password && <p className="terms-error">{errors.password.message}</p>}
            </div>
          )}
        />
      </div>

      <div>
        <Controller
          name="phoneNumber"
          control={control}
          defaultValue=""
          rules={{
            required: "Please enter your phone number.",
            pattern: {
              value: /^[6-9]\d{9}$/,
              message: "Please enter a valid 10-digit Indian mobile number.",
            },
          }}
          render={({ field }) => (
            <div className="input-container">
              <input
                type="tel"
                placeholder="WHATSAPP NO"
                maxLength={10}
                {...field}
              />
              {errors.phoneNumber && (
                <p className="terms-error">{errors.phoneNumber.message}</p>
              )}
            </div>
          )}
        />
      </div>
      <div>
        <Controller
          name="dob"
          control={control}
          defaultValue=""
          rules={{
            required: "Please enter your date of birth.",
            validate: (value) => {
              const dob = new Date(value);
              const today = new Date();

              let age = today.getFullYear() - dob.getFullYear();
              const monthDiff = today.getMonth() - dob.getMonth();

              if (
                monthDiff < 0 ||
                (monthDiff === 0 && today.getDate() < dob.getDate())
              ) {
                age--;
              }

              return age >= 14 || "You must be at least 14 years old.";
            },
          }}
          render={({ field }) => (
            <div className="input-container">
              <input
                type="date"
                max={new Date().toISOString().split("T")[0]}
                {...field}
              />
              {errors.dob && <p className="terms-error">{errors.dob.message}</p>}
            </div>
          )}
        />
      </div>
      <div>
        <Controller
          name="gender"
          control={control}
          defaultValue=""
          rules={{
            required: "Please select your gender.",
          }}
          render={({ field }) => (
            <div className="input-container">
              <select className="form-dropdown" {...field}>
                <option value="" disabled>
                  SELECT GENDER
                </option>
                <option value="female">Female</option>
                <option value="male">Male</option>
                <option value="other">Other</option>
                <option value="prefer_not_to_say">Prefer not to say</option>
              </select>

              {errors.gender && (
                <p className="terms-error">{errors.gender.message}</p>
              )}
            </div>
          )}
        />
      </div>
       <div id="msg91-captcha"></div>

      <div className="terms-container">
        <Controller
          name="acceptTerms"
          control={control}
          defaultValue={false}
          rules={{
            required: "Please accept the Terms & Conditions to continue.",
          }}
          render={({ field }) => (
            <label className="terms-label">
              <input
                type="checkbox"
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
              />

              <span>
                I agree to the{" "}
                <span
                  className="terms-link"
                  onClick={(e) => {
                    e.preventDefault();
                    openPolicy(
                      "terms-and-conditions",
                      "Terms & Conditions"
                    );
                  }}
                >
                  Terms & Conditions
                </span>{" "}
                and{" "}
                <span
                  className="terms-link"
                  onClick={(e) => {
                    e.preventDefault();
                    openPolicy(
                      "privacy-policy",
                      "Privacy Policy"
                    );
                  }}
                >
                  Privacy Policy
                </span>
              </span>
            </label>
          )}
        />



        {errors.acceptTerms && (
          <p className="terms-error">
            {errors.acceptTerms.message}
          </p>
        )}
      </div>
      <button className="create-btn" type="submit">
        Create Account
      </button>

      <Modal
        isOpen={showPolicyModal}
        toggle={() => setShowPolicyModal(false)}
        size="xl"
        centered
      >
        <ModalHeader toggle={() => setShowPolicyModal(false)}>
          {modalTitle}
        </ModalHeader>

        <ModalBody>
          <div
            style={{
              maxHeight: "70vh",
              overflowY: "auto",
            }}
            dangerouslySetInnerHTML={{
              __html: cmsPage?.content || "<p>Loading...</p>",
            }}
          />
        </ModalBody>

        {/* <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setShowPolicyModal(false)}
          >
            Close
          </Button>
        </ModalFooter> */}
      </Modal>
    </form>

  );
};

export default CreateAccount;
